import Config from '@config';
import { ReferenceBook } from '@gasbi/shared';

import { injectSupplySlice } from '@/app/supplyApi';
import { FiltersGrid, Pagination } from '@/features/types';
import {
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@/features/utils';

const api = injectSupplySlice({
  baseUrl: `${Config.VITE_API_URL}/positions`,
  tagTypes: ['Position'],
  endpoints: builder => ({
    getPositions: builder.query<ReferenceBook[], void>({
      query: () => ({ url: '', method: 'GET' }),
      providesTags: () => ['Position'],
    }),
    getPositionsI: builder.infiniteQuery<
      ReferenceBook[],
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '/query',
        method: 'GET',
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['Position'],
    }),
    getPositionById: builder.query<ReferenceBook, string>({
      query: id => ({ url: `/${id}`, method: 'GET' }),
      providesTags: (_result, _error, id) => [{ type: 'Position', id }],
    }),
    createPosition: builder.mutation<string, Pick<ReferenceBook, 'value'>>({
      query: data => ({ url: '', method: 'POST', data }),
      invalidatesTags: ['Position'],
    }),
    updatePosition: builder.mutation<
      void,
      { id: string; data: Omit<ReferenceBook, 'id'> }
    >({
      query: ({ id, data }) => ({ url: `/${id}`, method: 'PUT', data }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'Position', id },
        'Position',
      ],
    }),
  }),
});

export const positionsApi = api;

export const {
  useGetPositionsQuery,
  useGetPositionByIdQuery,
  useCreatePositionMutation,
  useUpdatePositionMutation,
} = api;

export const useGetPositionsInfiniteQuery = normalizeInfiniteQueryData(
  api.useGetPositionsIInfiniteQuery,
);
